import Cookies from 'js-cookie'

const Key = 'Travel'

// PCI DSS (TTGP-1590): the storefront language is kept in localStorage, not in a cookie. Nothing on the
// server reads it, and a cookie written by JS can never be HttpOnly, which the ASV scan reports.
// A value left in the old cookie is moved over on first read so returning visitors keep their language.
// The cookie is used again only when localStorage is unavailable (e.g. blocked storage).

function readStorage() {
  try {
    return window.localStorage.getItem(Key)
  } catch {
    return null
  }
}

function writeStorage(value) {
  try {
    window.localStorage.setItem(Key, value)
    return true
  } catch {
    return false
  }
}

function removeStorage() {
  try {
    window.localStorage.removeItem(Key)
  } catch {
    // storage unavailable: nothing stored there
  }
}

export function getLocale() {
  const stored = readStorage()
  if (stored) return stored
  const legacy = Cookies.get(Key)
  if (legacy && writeStorage(legacy)) Cookies.remove(Key)
  return legacy
}

export function setLocale(value) {
  if (writeStorage(value)) {
    Cookies.remove(Key)
    return value
  }
  // The write failed (blocked or quota full). Drop any older stored value, otherwise getLocale would keep
  // returning it instead of the cookie written below.
  removeStorage()
  return Cookies.set(Key, value, { expires: 300 })
}

export function removeLocale() {
  removeStorage()
  return Cookies.remove(Key)
}
